<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:15:09
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-04-02 16:19:35
 * @Description: 分卫星获取情况
 -->
<template>
  <div class="observe-satellite">
    <part-title title="卫星获取状态"></part-title>
    <div class="observe-satellite__chart">
      <!-- 按钮 -->
      <div class="observe-satellite__switch-container">
        <span :class="['observe-satellite__switch-btn',
          showType === 'view' ? 'observe-satellite__switch-btn--active' : null]"
          @click="chartChangeView()">景数</span>
        <span :class="['observe-satellite__switch-btn',
          showType === 'coverage' ? 'observe-satellite__switch-btn--active' : null]"
          @click="chartChangeCover()">覆盖率</span>
        <span class="observe-satellite__select">{{periodSelect.title}}</span>
      </div>
      <!-- echart 图表 -->
      <div class="observe-satellite__chart-container swiper-container" ref="swiper-container">
        <div class="swiper-wrapper">
          <div class="observe-satellite__chart-view swiper-slide" ref="monthViewChartDiv"></div>
          <div class="observe-satellite__chart-cover swiper-slide" ref="monthCoverChartDiv"></div>
          <div class="observe-satellite__chart-view swiper-slide" ref="seasonViewChartDiv"></div>
          <div class="observe-satellite__chart-cover swiper-slide" ref="seasonCoverChartDiv"></div>
          <div class="observe-satellite__chart-view swiper-slide" ref="yearViewChartDiv"></div>
          <div class="observe-satellite__chart-cover swiper-slide" ref="yearCoverChartDiv"></div>
        </div>
      </div>
      <!-- 左右 icon -->
      <div v-show="swiperIndex !== 0"
        class="observe-satellite__switch-icon observe-satellite__switch-icon--left"
        @click="chartChange('prev')">
      </div>
      <div v-show="swiperIndex !== 5"
        class="observe-satellite__switch-icon observe-satellite__switch-icon--right"
        @click="chartChange('next')">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Swiper from 'swiper'
// import 'swiper/css/swiper.css'
import PartTitle from '@/components/part-title'

moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
const PERIOD_DATA = [{
  title: '月',
  value: 'month',
  key: 2,
}, {
  title: '季',
  value: 'season',
  key: 1,
}, {
  title: '年',
  value: 'year',
  key: 0,
}]
export default {
  components: {
    PartTitle,
  },
  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      showType: 'view', // 可选 'view','coverage'
      satelliteViews: null,
      satelliteCover: null,
      periodSelect: PERIOD_DATA[0],
    }
  },
  computed: {
    ...mapGetters({
      monthSatelliteView: 'page/monthSatelliteView',
      monthSatelliteCover: 'page/monthSatelliteCover',
      seasonSatelliteView: 'page/seasonSatelliteView',
      seasonSatelliteCover: 'page/seasonSatelliteCover',
      yearSatelliteView: 'page/yearSatelliteView',
      yearSatelliteCover: 'page/yearSatelliteCover',
    }),
  },
  watch: {
    monthSatelliteView(newVal) {
      this.initViewChart(newVal, 'monthViewChartDiv')
    },
    monthSatelliteCover(newVal) {
      this.initCoverChart(newVal, 'monthCoverChartDiv')
    },
    seasonSatelliteView(newVal) {
      this.initViewChart(newVal, 'seasonViewChartDiv')
    },
    seasonSatelliteCover(newVal) {
      this.initCoverChart(newVal, 'seasonCoverChartDiv')
    },
    yearSatelliteView(newVal) {
      this.initViewChart(newVal, 'yearViewChartDiv')
    },
    yearSatelliteCover(newVal) {
      this.initCoverChart(newVal, 'yearCoverChartDiv')
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper()
    })
  },
  methods: {
    initSwiper() {
      // eslint-disable-next-line no-new
      this.swiper = new Swiper(this.$refs['swiper-container'], {
        loop: false, // 循环
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        touchStartPreventDefault: false, // 添加该属性
        on: {
          slideChange: this.slideChange,
        },
      })
    },
    slideChange() {
      const { activeIndex } = this.swiper
      this.swiperIndex = activeIndex
      const periodIndex = Math.floor(activeIndex / 2)
      this.periodSelect = PERIOD_DATA[periodIndex]

      this.showType = activeIndex % 2 === 0 ? 'view' : 'coverage'
    },
    /**
     * @description: 切换图表
     * @param {type} String 控制切换方向，'prev','next'
     */
    chartChange(direction) {
      if (direction === 'next') {
        this.swiper.slideNext()
      } else {
        this.swiper.slidePrev()
      }
    },
    chartChangeView() {
      const { activeIndex } = this.swiper
      if (activeIndex % 2 === 1) {
        this.swiper.slidePrev()
      }
    },
    chartChangeCover() {
      const { activeIndex } = this.swiper
      if (activeIndex % 2 === 0) {
        this.swiper.slideNext()
      }
    },
    initViewChart(chartData, domRef) {
      const yAxisName = '( 景 )'
      const legendData = [ '本期景数', '本期景数' ]
      const colors = [ '#F74C32', 'rgba(247,76,50, 0.1)', '#29B7A3' ]
      const option = this.getOption({
        yAxisName, legendData, chartData, colors,
      })

      const viewChart = this.$echarts.init(this.$refs[domRef])
      viewChart.setOption(option)
    },
    initCoverChart(chartData, domRef) {
      const yAxisName = '( % )'
      const legendData = [ '本期覆盖率', '本期覆盖率' ]
      const colors = [ '#45AAFB', 'rgba(69,170,251,0.1)', '#EB4DDB' ]
      const option = this.getOption({
        yAxisName, legendData, chartData, colors,
      })

      const coverChart = this.$echarts.init(this.$refs[domRef])
      coverChart.setOption(option)
    },
    getOption({
      yAxisName, legendData, chartData, colors,
    }) {
      return {
        color: colors,
        grid: {
          top: 50,
          right: 35,
          left: 75,
          bottom: 90,
        },
        xAxis: {
          type: 'category',
          data: chartData.map(i => i.name),
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
          // boundaryGap: false,
          axisLabel: {
            color: '#737373',
            rotate: 45,
            margin: 15,
            textStyle: {
              fontSize: 16,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
            },
          },
        },
        yAxis: {
          name: yAxisName,
          nameTextStyle: {
            fontSize: 16,
            color: '#737373',
            align: 'right',
            padding: [ 0, 5, 10, 0 ],
          },
          boundaryGap: false,
          axisLabel: {
            color: '#737373',
            textStyle: {
              fontSize: 16,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EFEFEF',
            },
          },
        },
        series: [
          {
            type: 'bar',
            name: legendData[0],
            data: chartData,
            barWidth: '12px',
            barGap: '100%',
            label: {
              normal: {
                show: true,
                color: colors[0],
                backgroundColor: colors[1],
                borderRadius: 20,
                fontFamily: 'PingFangSC-Regular,PingFang SC',
                align: 'center',
                position: 'top',
                padding: [ 3, 5, 0, 5 ],
              },
            },
          },
          // {
          //   type: 'bar',
          //   barGap: '100%',
          //   name: legendData[1],
          //   data: chartData.year,
          //   barWidth: '12px',
          //   label: {
          //     normal: {
          //       show: true,
          //       color: colors[1],
          //       align: 'center',
          //       position: 'top',
          //       padding: [ 3, 5, 0, 5 ],
          //     },
          //   },
          // },
        ],
      }
    },
  },
}
</script>

<style lang="scss">
.observe-satellite {
  position: relative;
  padding: 0 35px;
}

.observe-satellite__chart {
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0,0,0,.2);
}

// 按钮
.observe-satellite__switch-container {
  padding: 30px 25px;
  padding-bottom: 10px;
  font-family: PingFangSC-Medium,PingFang SC;
  font-size: 20px;
  font-weight: 500;
  color: #666;
}
.observe-satellite__switch-btn {
  margin-right: 30px;
  &:hover {
    cursor: pointer;
  }
}
.observe-satellite__switch-btn--active {
  font-size: 28px;
  color: #005EFF;
}
.observe-satellite__select {
  position: absolute;
  right: 66px;
  width: 56px;
  height:34px;
  display: inline-block;
  text-align: center;
  background:rgba(241,245,255,1);
  border-radius:12px;
  border:1px solid rgba(204,222,255,1);
  font-size:20px;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(0,94,255,1);
  // &:hover {
  //   cursor: pointer;
  // }
}
.observe-satellite__drop-down {
  width: 56px;
}

.observe-satellite__switch-icon {
  position: absolute;
  top: 52%;
  width: 50px;
  height: 50px;
  background-image: url(../../../assets/images/right.png);
  cursor: pointer;
  z-index: 2;
}
.observe-satellite__switch-icon--left {
  left: 10px;
  transform: rotate(180deg);
}
.observe-satellite__switch-icon--right {
  right: 10px;
}
.observe-satellite__chart-container {
  height: 350px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  // div {
  //   width: 100%;
  //   height: 100%;
  //   display: inline-block;
  // }
}
</style>
